module.exports = __webpack_public_path__ + "fonts/MonlamUniOuChan2.eot";